import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core';
import { TPicture } from '../../../types/cloudStorage/CloudFileList';
import { Grid, Tooltip, Theme } from '@material-ui/core';
import { formatDataSize } from '../../../utils/common';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

type Tprops = {
  picture: TPicture;
  setPictureId?: React.Dispatch<React.SetStateAction<number | undefined>>;
  openDetailModal?: boolean;
  setOpenDetailModal?: React.Dispatch<React.SetStateAction<boolean>>;
  src?: string;
};

export const PictureImage: React.FC<Tprops> = (props: Tprops) => {
  const { picture, openDetailModal, setOpenDetailModal, setPictureId, src } =
    props;

  // サイズ調整
  const theme = useTheme();
  const isWideScreen = useMediaQuery(theme.breakpoints.up('md'));

  // ツールチップ内部
  const PictureInfo = (
    <>
      <div>{picture.shooting_date}</div>
      <div>{formatDataSize(picture.size)}</div>
      <div>{picture.description}</div>
    </>
  );

  // ツールチップスタイル
  const PictureTooltip = withStyles((theme: Theme) => ({
    tooltip: {
      width: 200,
      fontSize: 16
    }
  }))(Tooltip);

  return (
    <>
      {src ? (
        <>
          {setPictureId && setOpenDetailModal ? (
            <PictureTooltip title={PictureInfo} placement='top'>
              <Grid item>
                <img
                  src={src}
                  alt={picture.file_name}
                  style={{
                    cursor: 'pointer',
                    border: '1px solid #cfcfcf',
                    borderRadius: 5,
                    width: isWideScreen ? 162 : 142,
                    height: isWideScreen ? 122 : 106,
                    objectFit: 'cover'
                  }}
                  onClick={() => {
                    setPictureId(picture.id);
                    setOpenDetailModal(true);
                  }}
                />
              </Grid>
            </PictureTooltip>
          ) : (
            <Grid item>
              <img src={src} alt={picture.shooting_date} />
            </Grid>
          )}
        </>
      ) : (
        <Grid item>
          <div style={{ width: 162, height: 122 }}></div>
        </Grid>
      )}
    </>
  );
};
